/**
 * 日期工具函数
 * 提供动态年份获取功能
 */

/**
 * 获取选择的年份
 * @returns {string} 选择的年份字符串
 */
export function getFallbackYear() {
  return String(new Date().getFullYear())
}

export function getSelectedYear() {
  let selectedYear = localStorage.getItem('selectedYear')
  if (selectedYear && /^\d{4}$/.test(selectedYear)) {
    return selectedYear
  }
  return getFallbackYear()
}

/**
 * 获取选择的年份的前一年
 * @returns {string} 选择的年份的前一年字符串
 */
export function getSelectedYearPreviousYear() {
  let selectedYear = getSelectedYear()
  return (parseInt(selectedYear, 10) - 1).toString()
}

/**
 * 获取默认年份（当前年份）
 * @returns {string} 默认年份字符串
 */
export function getDefaultYear() {
  return getSelectedYear()
}

/**
 * 获取流感季年份范围
 * @param {string} year - 起始年份
 * @returns {string} 流感季年份范围（如：2024-2025）
 */
export function getInfluenzaSeasonRange(year, region) {
  let hem = region || localStorage.getItem('selectedRegion') || localStorage.getItem('selectedHemisphere') || 'North'
  let startYear = parseInt(year, 10)
  if (!Number.isFinite(startYear)) {
    startYear = parseInt(getFallbackYear(), 10)
  }
  if (hem === "North") {
    return `${startYear}-${startYear + 1}`
  }
  return `${startYear}`
}

/**
 * 获取默认亚型
 * @returns {string} 默认亚型
 */
export function getDefaultSubtype() {
  return localStorage.getItem('selectedSubtype') || 'H3N2'
}

/**
 * 获取默认半球
 * @returns {string} 默认半球
 */
export function getDefaultHemisphere() {
  return localStorage.getItem('selectedRegion') || localStorage.getItem('selectedHemisphere') || 'North'
}

/**
 * 生成疫苗描述映射对象
 * @returns {object} 疫苗描述映射对象
 */
export function getVaccineDescriptionMap(year) {
  let currentYear = String(year || getSelectedYear())
  let previousYear = (parseInt(currentYear, 10) - 1).toString()
  let nextYear = (parseInt(currentYear, 10) + 1).toString()

  return {
    [`FutureFlu${previousYear}North`]: `FutureFlu recommends vaccine for use in the ${previousYear}-${currentYear} northern hemisphere influenza season`,
    [`FutureFlu${currentYear}North`]: `FutureFlu recommends vaccine for use in the ${currentYear}-${nextYear} northern hemisphere influenza season`,
    [`WHO${previousYear}North`]: `WHO recommends vaccine for use in the ${currentYear}-${nextYear} northern hemisphere influenza season`,
    [`FutureFlu${previousYear}South`]: `FutureFlu recommends vaccine for use in the ${previousYear} southern hemisphere influenza season`,
    [`FutureFlu${currentYear}South`]: `FutureFlu recommends vaccine for use in the ${currentYear} southern hemisphere influenza season`,
    [`WHO${previousYear}South`]: `WHO recommends vaccine for use in the ${previousYear} southern hemisphere influenza season`
  }
}

export function parseSequenceCount(value) {
  if (value === null || value === undefined) {
    return null
  }
  let text = String(value).trim()
  if (!text) {
    return null
  }
  let parsed = parseInt(text, 10)
  return Number.isFinite(parsed) ? parsed : null
}

export function formatSequenceCount(value) {
  let parsed = typeof value === 'number' ? value : parseSequenceCount(value)
  if (parsed === null || Number.isNaN(parsed)) {
    return ''
  }
  return parsed.toLocaleString()
}

export const RISK_DISPLAY_CLADE_ALIASES = {
  H3N2: {
    A: '3C',
    'G.1.3.1': '3C.2a1b.2a.2a.3a',
  },
}

export function displayLineageLabel(label, subtype) {
  let text = String(label || '').trim()
  if (!text) {
    return ''
  }
  let aliases = RISK_DISPLAY_CLADE_ALIASES[String(subtype || '').toUpperCase()] || {}
  return aliases[text] || text
}

export function isAmbiguousMutationToken(token) {
  let text = String(token || '').trim()
  return /^[X?\-]/.test(text) || /[X?\-]$/.test(text)
}

export function filterMutationChips(value) {
  return String(value || '')
    .split(',')
    .map((item) => item.trim())
    .filter((item) => item && !isAmbiguousMutationToken(item))
}